/* eslint-disable react/prefer-stateless-function */
import React, { Component } from 'react';

import { Button, Image } from 'semantic-ui-react';

import courseDefault from '../img/default-course.svg';

import '../css/BookImageCard.less';

import { SatCoreRegister } from '../SatCoreRegistry';

import { CONTENT_ITEM_TYPES } from '../managers/ContentManager';

import UtilityService from '../services/UtilityService';

import { stripHtmlTags } from '../utils';

export default class BookImageCard extends Component {
  render() {
    const { course, customDefaultCardImg, showBook, disabled } = this.props;
    const nameObj = UtilityService.reactHtmlParserWrapper(course.name);
    let image = null;

    if (course?.imageUrl) {
      image = <Image alt={course?.altText ? course.altText : null} fluid src={CONTENT_ITEM_TYPES.getContentImageUrl(course.imageUrl)} />;
    } else if (customDefaultCardImg) {
      image = <Image fluid src={customDefaultCardImg} />;
    }
    return (
      <div className={`book-card-container${disabled ? ' disabled' : ''}`}>
        <div className={`course-card-image ${!image ? 'default-image' : ''}`}>
          {!image ? <Image src={courseDefault} /> : image}
        </div>
        <div className='course-name'>
          <span title={nameObj.stripped}>
            {nameObj.parsed}
          </span>
        </div>
        <div className='actions'>
          <Button
            aria-label={`Open ${stripHtmlTags(course.name)}`}
            className='open-course-button'
            disabled={disabled}
            onClick={() => showBook(course.id)}
            primary
            tabIndex={-1}
            type='button'>
            Open
          </Button>
        </div>
      </div>
    );
  }
}

SatCoreRegister('BookImageCard', BookImageCard);
